import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ButtonEditor } from "../PrimaryButtonBlock/Editor";
import { CustomButton } from "./CustomButton";
import { defaultData } from "./CustomButtonBlockDefaultData";
import { meta } from "./CustomButtonBlockMetaData";

export const CustomButtonBlock: BlockExport = {
  type: "component",
  Block: CustomButton,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-button",
    size: 24,
  },
  defaultData,
  Editor: ButtonEditor,
  meta,
};
